/**
 * A random UUID, in and out of a secure context.
 *
 * `crypto.randomUUID` exists only on HTTPS and localhost, and a relaii server
 * on a plain-HTTP LAN address is a perfectly ordinary deployment, so there is
 * a real fallback rather than a crash: the same v4 shape from
 * `getRandomValues`, or from `Math.random` where even that is missing. Nothing
 * here is a secret — these are identifiers, never key material.
 */
export function randomUuid(): string {
  if (typeof crypto !== 'undefined') {
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()

    if (typeof crypto.getRandomValues === 'function') {
      const bytes = crypto.getRandomValues(new Uint8Array(16))
      const byte = (index: number): number => bytes[index] ?? 0
      // RFC 4122 version and variant bits.
      bytes[6] = (byte(6) & 0x0f) | 0x40
      bytes[8] = (byte(8) & 0x3f) | 0x80
      const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('')
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
    }
  }

  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 14)}`
}
